import { api } from './api';
import { SubscriptionPlan } from "../types/SubscriptionPlan";

// Fetch all plans
export const getSubscriptionPlans = () =>
    api.get<SubscriptionPlan[]>('/admin/subscription-plans');

export const createSubscriptionPlan = (data: Partial<SubscriptionPlan>) =>
    api.post<{ message: string; plan: SubscriptionPlan }>('/admin/subscription-plans', data);

// Update a specific plan
export const updateSubscriptionPlan = (id: number, data: Partial<SubscriptionPlan>) =>
    api.patch<{ message: string; plan: SubscriptionPlan }>(`/admin/subscription-plan/${id}`, data);